document.addEventListener("DOMContentLoaded", () => {
  initSliders();
  initDialogs();
});

const imageSliderOptions = {
  type: "slide",
  perPage: 4,
  perMove: 1,
  gap: 48,
  focus: 0,
  omitEnd: true,
  arrows: false,
  pagination: true,
  dragMinThreshold: 1,
  flickMaxPages: 1,
  autoHeight: true,
  breakpoints: {
    959: { perPage: 3, gap: 24 },
    559: {
      perPage: 1.5,
      gap: 20,
      focus: "center",
      padding: { left: 20, right: 20 },
    },
  },
  classes: {
    pagination: "product-coordinate--pagination unstyled-list",
    page: "splide__pagination__page dot",
  },
};

const popupSliderOptions = {
  type: "fade",
  perPage: 1,
  perMove: 1,
  arrows: true,
  arrowPath: "M10.5,1l19,19-19,19",
  pagination: true,
  classes: {
    arrow: "splide__arrow dialog-arrow",
    prev: "splide__arrow--prev prev",
    next: "splide__arrow--next next",
    pagination: "splide__pagination dialog-pagination",
    page: "splide__pagination__page dot",
  },
};

function initSliders() {
  const mainSlider = createSplideSlider("#image-slider", imageSliderOptions);
  const popupSlider = createSplideSlider("#popup-slider", popupSliderOptions);

  mainSlider.on("click", (slide) => popupSlider.go(slide.index));
}

function createSplideSlider(selector, options) {
  const slider = new Splide(selector, options);
  slider.mount();
  return slider;
}

function initDialogs() {
  const showButtons = document.querySelectorAll("[data-popover-button]");
  showButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const targetID = button.getAttribute("popovertarget");
      const targetDialog = document.getElementById(targetID);
      if (!targetDialog) return;
      document.body.classList.toggle("overflow-hidden");
      setTimeout(() => targetDialog.classList.toggle("is-show"), 100);
    });
  });

  const hideButton = document.querySelector("[data-dialog-hide]");
  if (!hideButton) return;
  hideButton.addEventListener("click", (e) => {
    e.preventDefault();
    const targetID = hideButton.getAttribute("popovertarget");
    const targetDialog = document.getElementById(targetID);
    if (!targetDialog) return;
    targetDialog.classList.toggle("is-show");
    document.body.classList.toggle("overflow-hidden");
    setTimeout(() => targetDialog.hidePopover?.(), 200);
  });
}
